export default {
    methods: {
        async assignBus(shouldAssign, resId, busId, edit=true, loadData=true) {
            let bookingData = {
                id: resId,
                newData: {
                    bus_type: this.path,
                    edit: edit,
                },
                loadData: loadData
            };

            let action = "assignBus";
            shouldAssign
                ? (bookingData.newData.bus_id = busId)
                : (action = "deassignBus");

            try {
                bookingData.show_spinner=false
                await this.$store.dispatch(`bookingsBus/${action}`, bookingData);
            } catch (ex) {
                this.error = "Failed to load data";
            }
        }
    }
}